// src/pages/Terminos.jsx
import React from "react";

const Invoices = () => {
  return (
    <div className="terminos-container">
      <iframe
        src="/assets/archivos/MANUAL DE USUARIO - CREACION Y EDICION DE FACTURA.pdf"
        title="Registro de Facturas"
        className="pdf-viewer"
        frameBorder="0"
      ></iframe>
    </div>
  );
};

export default Invoices;
